import React from 'react';
import { useLocation } from 'react-router-dom';

import { AdminListPageConfig, AdminListPageRenderer, TabDef, useAdminListPage } from 'hooks/useAdminListPage';
import { PERMISSIONS } from 'models/Profile';

type PermissionKey = keyof typeof PERMISSIONS;

export interface TabbedAdminListPageTab<T = any> {
  label: string;
  path: string;
  permission?: PermissionKey;
  config: AdminListPageConfig<T>;
}

function TabPanel({ tab, pageTitle, tabDefs }: { tab: TabbedAdminListPageTab; pageTitle: string; tabDefs: TabDef[] }) {
  const state = useAdminListPage(tab.config);

  return (
    <AdminListPageRenderer
      config={tab.config}
      state={state}
      tabs={{ pageTitle, tabDefs, currentTabLabel: tab.label }}
    />
  );
}

export default function TabbedAdminListPage({
  pageTitle,
  tabs,
}: {
  pageTitle: string;
  tabs: TabbedAdminListPageTab[];
}) {
  const location = useLocation();

  const tabDefs: TabDef[] = tabs.map((t) => ({
    label: t.label,
    path: t.path,
    ...(t.permission ? { permission: t.permission } : {}),
  }));

  const activeTab = tabs.find((t) => t.path === location.pathname) ?? tabs[0];

  return <TabPanel key={activeTab.path} tab={activeTab} pageTitle={pageTitle} tabDefs={tabDefs} />;
}
